import React from 'react'

import type { WatermarkingQuota } from '@disco/utils/getWatermarkingQuota'

import Alert from 'components/ui/alert'
import InlineLink from 'components/ui/inline-link'
import styles from './index.module.css'

const WatermarkingQuotaAlert = ({
  quotaUsed,
  quota,
  quotaUnlimited,
}: WatermarkingQuota): React.ReactElement<'div'> => {
  let status: React.ComponentProps<typeof Alert>['status'] = 'warning'
  let message = 'You’re not currently subscribed to watermarking. Re-subscribe'
  let linkMessage = 'here.'

  if (quota) {
    message = `You’re using ${quotaUsed} of your ${quota} watermarked playlists.`
    linkMessage = 'Manage Plan'
    status = 'info'

    if (quotaUnlimited) {
      message = `You’re using ${quotaUsed} playlists on the unlimited watermarking plan.`
    }
  }

  if (quota === quotaUsed) {
    linkMessage = 'Upgrade'
    status = 'warning'
  }

  return (
    <div className={styles.watermarkingQuotaAlert}>
      <Alert status={status}>
        {message} <InlineLink to="/settings/billing">{linkMessage}</InlineLink>
      </Alert>
    </div>
  )
}

export default WatermarkingQuotaAlert
